"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Arrowright = function Arrowright(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "ArrowrightTitle ArrowrightDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "ArrowrightTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "ArrowrightDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M17.26 12.853l-12.44.008a.797.797 0 0 1-.58-.252.89.89 0 0 1 0-1.215.797.797 0 0 1 .58-.252h12.43l-3.631-3.46a.815.815 0 0 1-.245-.58c0-.224.093-.428.244-.578a.877.877 0 0 1 .608-.241c.238 0 .453.092.608.24l4.981 4.756a1 1 0 0 1 0 1.446l-4.979 4.755a.879.879 0 0 1-.608.24c-.474 0-.86-.367-.86-.82 0-.225.097-.43.253-.578l3.64-3.469z",
    id: "refArrowrightE_pRDScqgk"
  })), /*#__PURE__*/_react["default"].createElement("use", {
    xlinkHref: "#refArrowrightE_pRDScqgk"
  }));
};

Arrowright.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Arrowright.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Arrowright;
exports["default"] = _default;